import React, { Fragment ,useEffect} from "react";
import Dashboard from "../Common/Components/Dashboard";
import CountChartWidget from "./CountChartWidget";
import Filters from "../Devices/Filter";
import CountGridWidget from "./CountGridWidget";
import DashboardOptions from "../Common/Components/DashboardOptions";
import { useAppDispatch } from "../Core/store.hooks";
import { fetchVeryShortCount } from "./countSlice";
import { useSelector } from 'react-redux';
import { getParamsSelector } from '../Common/Slices/ParamSlice';

const CountIndex = () =>{
    const dispatch = useAppDispatch();
    const params = useSelector(getParamsSelector);
    useEffect(() => {
        if (params != null) {
            fetchVeryShortCount(params);
        }
    }, [params]);
    const positionData = [
        {col:1,colSpan: 3, rowSpan:6},
        {col:4,colSpan: 3, rowSpan:6}
    ];

    const sidebarItems = [
        {title:"Filters",item:<Filters id="14" deviceWithSerialInput={false}/>, expanded:true},
        {title: "Dashboard Options", item: < DashboardOptions />, expanded: true }
    ];

    return (
        <Fragment>
            <Dashboard positionData={positionData} sidebarItems={sidebarItems}>
                <CountChartWidget id="12" header="Very Short Running Periods Count"/>
                <CountGridWidget id="grid1" header ="Very Short Running Periods Count"/>
            </Dashboard>
        </Fragment>
    )
}

export default CountIndex;